import type { LocationType } from '@ecomm/framework'
export function getSearchParams(windowLocation: LocationType) {
  const params = new URLSearchParams(
    windowLocation.search.slice(windowLocation.search.indexOf('?'))
  )
  return Object.fromEntries(params.entries())
}
